export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-postnl.6a0ad399.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};